/**
 * Polyfills for browser compatibility
 * This is the main entry point for all polyfills
 */

// Import individual polyfill modules
require('./promise-polyfills');

// Export for CommonJS only - no ES Module exports
module.exports = {};
